import { useNavigate, useParams } from "react-router-dom";
import Project from "rwb/types/interfaces/project";
import { useFetcher } from "~/hooks/useFetcher";
import { ROUTE_404 } from "~/router/constants";

const { VITE_RWB_API } = import.meta.env;

const useProject = (id?: string | number) => {
  const navigate = useNavigate();
  const { projectId = id } = useParams();
  const resp = useFetcher<Project>(projectId ? `${VITE_RWB_API}/projects/${projectId}` : null);

  if (resp.error?.status >= 400 && resp.error?.status < 500) {
    navigate(ROUTE_404, { replace: true });
  }

  return resp;
};

export default useProject;
